export const NeuralGlobeLogo = ({ className = "w-6 h-6" }: { className?: string }) => {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      className={className}
    >
      {/* Globe circle */}
      <circle cx="12" cy="12" r="9" />
      
      {/* Vertical meridian */}
      <ellipse cx="12" cy="12" rx="3.5" ry="9" />
      
      {/* Horizontal lines */}
      <path d="M3 12h18" />
      <path d="M5.5 7.5h13" />
      <path d="M5.5 16.5h13" />
      
      {/* Neural network connection nodes */}
      <circle cx="12" cy="3" r="1" fill="currentColor" />
      <circle cx="21" cy="12" r="1" fill="currentColor" />
      <circle cx="12" cy="21" r="1" fill="currentColor" />
      <circle cx="3" cy="12" r="1" fill="currentColor" />
      
      {/* Abstract neural lines */}
      <path d="M12 3 L 21 12" strokeWidth="0.5" opacity="0.5" />
      <path d="M21 12 L 12 21" strokeWidth="0.5" opacity="0.5" />
      <path d="M12 21 L 3 12" strokeWidth="0.5" opacity="0.5" />
      <path d="M3 12 L 12 3" strokeWidth="0.5" opacity="0.5" />
    </svg>
  );
};
